const AppConfig = {
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  API_URL: process.env.REACT_APP_SERVER_API_URL,
  MASJID_DOMAIN: process.env.REACT_APP_MASJID_DOMAIN ?? 'ihsaan.digital',
  FUNDRAISE_DOMAIN: process.env.REACT_APP_FUNDRAISE_DOMAIN ?? 'fundraise.amanahfy.com',
  GOCARDLESS_MODE: process.env.REACT_APP_GOCARDLESS_MODE || 'sandbox',
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
};
export default AppConfig;
